module.exports = __webpack_public_path__ + "img/member01.c8d34f80.png";